class CaldrisProtection extends HTMLElement {
 connectedCallback() {
  this.querySelector('input').addEventListener('change', () => this.update());
 }
 async update() {
  const input = this.querySelector('input'); const selected = input.checked;
  const root = window.Shopify?.routes?.root || '/';
  const drawer = document.querySelector('cart-drawer');
  const inDrawer = !!this.closest('cart-drawer');
  input.disabled = true;
  const checkout = document.querySelectorAll('[name="checkout"]'); checkout.forEach(b => b.disabled = true);
  try {
   const sections = ['cart-drawer','cart-icon-bubble'];
   const response = await fetch(root + (selected ? 'cart/add.js' : 'cart/change.js'), {
    method:'POST', headers:{'Content-Type':'application/json'},
    body:JSON.stringify({...selected ? {items:[{id:Number(this.dataset.variant),quantity:1}]} : {id:this.dataset.key,quantity:0}, sections,sections_url:location.pathname})
   });
   const data = await response.json(); if (!response.ok || data.errors) throw Error(data.description || data.errors);
   if (inDrawer && data.sections?.['cart-drawer']) {
    drawer.renderContents(data);
    drawer.querySelector('caldris-protection input')?.focus();
   } else location.reload();
  } catch(error) {
   input.checked = !selected;
   this.querySelector('[data-protection-error]').textContent = document.documentElement.lang==='fr' ? 'Impossible de modifier la protection. Veuillez réessayer.' : 'Unable to update protection. Please try again.';
  } finally {input.disabled = false; checkout.forEach(b => b.disabled = false);}
 }
}
customElements.define('caldris-protection',CaldrisProtection);
